import { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { InView } from "react-intersection-observer";
import ProductImageContainer from "../ProductImageContainer";
import Image from "../Image";
import PlaceholderImage from "../PlaceholderImage";
import styles from "./index.css";

const triggerOnce = true;

class LazyProductImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false
    };
  }

  onLoad = () => {
    this.setState({
      ...this.state,
      loaded: true
    });
  };

  render() {
    const {
      onLoad,
      props: { badgeType, rootMargin, className, ...rest },
      state: { loaded }
    } = this;

    return (
      <InView rootMargin={rootMargin} triggerOnce={triggerOnce}>
        {({ inView, ref }) => (
          <ProductImageContainer badgeType={badgeType} forwardRef={ref}>
            {inView ? (
              <Image
                {...rest}
                className={classnames(
                  styles.lazy,
                  {
                    [styles.show]: loaded
                  },
                  className
                )}
                onLoad={onLoad}
              />
            ) : (
              <PlaceholderImage {...rest} />
            )}
          </ProductImageContainer>
        )}
      </InView>
    );
  }
}

LazyProductImage.propTypes = {
  badgeType: PropTypes.oneOf(["MixMatch", "MoreColors"]),
  rootMargin: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default LazyProductImage;
